import React, { createContext, useContext } from "react";
import propTypes from "prop-types";

export const MultiSelectContext = createContext({
  disabled: false,
  filter: "",
  id: "",
  name: "",
  onChange: () => {},
  readOnly: false,
  value: [],
});

export const MultiSelectProvider = ({ children, value }) => (
  <MultiSelectContext.Provider value={value}>
    {children}
  </MultiSelectContext.Provider>
);

MultiSelectProvider.propTypes = {
  children: propTypes.node,
  value: propTypes.object,
};

export const useMultiSelect = () => useContext(MultiSelectContext);
